<template>
  <v-dialog v-model="dialog" width="900" scrollable>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <add-button v-if="!id"></add-button>
        <edit-icon-button v-else></edit-icon-button>
      </div>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            label="Field Name"
            v-model="form.name"
            outlined
            :rules="rules"
            dense
          ></v-text-field>
          <v-autocomplete
            label="Field Type"
            item-text="name"
            :disabled="item.is_fixed"
            :rules="rules"
            item-value="value"
            v-model="form.field_type"
            :items="types"
            outlined
            dense
          ></v-autocomplete>
          <v-row>
            <v-col class="pt-0">
              <v-checkbox
                label="Used in Calculation?"
                hide-details=""
                v-model="form.is_used"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0">
              <v-checkbox
                label="Is Required?"
                hide-details=""
                v-model="form.is_required"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0">
              <v-checkbox
                hide-details=""
                label="Calculated Field?"
                v-model="form.is_calculated"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0">
              <v-checkbox
                hide-details=""
                label="Searchable?"
                v-model="form.is_searchable"
              ></v-checkbox>
            </v-col>
          </v-row>
          <options v-model="form.options" v-if="isOption"></options>
          <formula
            v-if="form.is_calculated"
            ref="formula"
            v-model="form.formula"
          ></formula>
          <default-field
            v-if="!form.is_calculated"
            v-model="form.default_field"
            :field="form"
          ></default-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate } from "../../../assets/js/common";
import { fieldTypes } from "../../../assets/js/default";
import { globalFields } from "../../../assets/js/firebase";
import { FIELD } from "../../../assets/js/rules";
import AddButton from "../../buttons/AddButton.vue";
import EditIconButton from "../../buttons/EditIconButton.vue";
import Formula from "./Formula.vue";
import Options from "../Options.vue";
import DefaultField from "./DefaultField.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { AddButton, Options, EditIconButton, Formula, DefaultField },
  data() {
    return {
      dialog: false,
      isValid: false,
      rules: FIELD,
      form: {},
    };
  },
  computed: {
    isOption() {
      const { field_type } = this.form;
      return field_type == "select" || field_type == "autocomplete";
    },
    types() {
      return fieldTypes.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    title() {
      return this.id ? "Edit Global Field" : "Add New Global Field";
    },
    id() {
      return this.item.id;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { form, isOption } = vm;

       if (Array.isArray(vm.form.options)) {
    vm.form.options = vm.form.options.filter(option => {
      const name = (option.name || "").trim();
      const value = (option.value || "").trim();

      // Keep only options that have some data
      return name !== "" || value !== "";
    })
    .map(option => ({ ...option}));
    vm.$nextTick(() => {
  vm.$refs.optionsTable.refresh();
});
  }
      if (form.options.length == 0 && isOption) {
        vm.$root.alert("Please add atleast one option");
        return;
      }
      if (vm.form.is_calculated && vm.$refs.formula.errorMessage) {
        console.log("Please check the formula");
        return;
      }
      let name = vm.form.name.trim();
      let lower = name.toLowerCase();
      let updated_at = getDate();
      let doc = { lower, updated_at, name };
      Object.keys(vm.form).forEach((key) => {
        doc[key] = vm.form[key];
      });
      doc.name = name;
      if (vm.id) {
        vm.update(doc);
      } else {
        vm.create(doc);
      }
    },
    async create(doc) {
      const vm = this;
      vm.$root.loader = true;
      try {
        let snap = await globalFields
          .where("lower", "==", doc.lower)
          .limit(1)
          .get();
        if (!snap.empty) {
          vm.$root.loader = false;
          vm.$root.alert(
            "Another global field already exists with the same name. Please enter a unique name."
          );
          return;
        }
        doc.created_at = getDate();
        doc.type = "global";
        await globalFields.add(doc);
        vm.dialog = false;
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async update(doc) {
      const vm = this;
      vm.$root.loader = true;
      try {
        let snap = await globalFields
          .where("lower", "==", doc.lower)
          .limit(1)
          .get();
        if (!snap.empty && snap.docs[0].id != vm.id) {
          vm.$root.loader = false;
          vm.$root.alert(
            "Another global field already exists with the same name. Please enter a unique name."
          );
          return;
        }
        await globalFields.doc(vm.id).update(doc);
        vm.dialog = false;
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },

    init() {
      const vm = this;
      vm.form = {
        name: "",
        field_type: "text",
        formula: "",
        is_fixed: false,
        is_required: true,
        is_calculated: false,
        is_used: false,
        options: [],
        is_searchable: false,
        default_field: {
          type: "global",
          global: "",
          service: {},
        },
      };
      if (vm.id) {
        Object.keys(vm.form).forEach((key) => {
          if (vm.item[key] != undefined) {
            vm.form[key] = vm.item[key];
          }
        });
        console.log(vm.form);
        setTimeout(() => {
          try {
            if (vm.item.formula) {
              vm.$refs.formula.init(vm.item.formula);
            }
          } catch (error) {
            console.log(error.message);
          }
        }, 100);
      } else {
        vm.dialog = true;
      }
    },
  },
};
</script>

<style></style>
